import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { toggleButtonsArrayButton } from './actions'

function mapStateToProps(state, hocProps) {
    const activeReport = state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', 'reports', 'active'])

    return {
        active: state.getIn(
            ['ui', 'modules', hocProps.moduleName, 'ribbon', hocProps.arrayName, 'data', hocProps.name],
            false
        ),
        isNew: state.getIn(
            [
                'authorization',
                'accessRights',
                hocProps.moduleName,
                'custom',
                'reports',
                activeReport,
                'blocks',
                hocProps.name,
                'flags',
                'new',
            ],
            false
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleButtonsArrayButton }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            active: PropTypes.bool.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (this.props.active !== nextProps.active) return true
            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
